import { MessageSquareText, Star, UtensilsCrossed, BedDouble, Smile, AlertTriangle } from "lucide-react";

const Card = ({ testId, icon: Icon, label, children, tone = "emerald", className = "" }) => (
  <div data-testid={testId} className={`glass rounded-3xl p-5 rise ${className}`}>
    <div className="flex items-center justify-between">
      <span className="field-label">{label}</span>
      <span className={`h-9 w-9 rounded-xl grid place-items-center ${tone === "red" ? "bg-red-100 text-red-600" : tone === "amber" ? "bg-amber-100 text-amber-700" : "bg-emerald-100 text-emerald-700"}`}>
        <Icon className="h-4 w-4" />
      </span>
    </div>
    <div className="mt-3">{children}</div>
  </div>
);

const Big = ({ children, testId }) => <div data-testid={testId} className="font-display text-4xl font-extrabold tracking-tight text-emerald-950">{children}</div>;
const fmt = (v) => (v == null ? "—" : v.toFixed(2));

export const KpiCards = ({ k }) => {
  const wkDelta = k.this_week.avg != null && k.last_week.avg != null ? k.this_week.avg - k.last_week.avg : null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
      <Card testId="kpi-total" icon={MessageSquareText} label="Total feedback" className="d1">
        <Big testId="kpi-total-value">{k.total}</Big>
        <div className="mt-1 text-xs text-slate-500">{k.this_week.count} in last 7 days</div>
      </Card>
      <Card testId="kpi-avg-rating" icon={Star} label="Avg overall rating" tone="amber" className="d2">
        <Big testId="kpi-avg-rating-value">{fmt(k.avg_rating)}<span className="text-lg text-slate-400 font-semibold"> / 5</span></Big>
        {wkDelta != null && (
          <div className={`mt-1 text-xs font-semibold ${wkDelta >= 0 ? "text-emerald-700" : "text-red-600"}`}>
            {wkDelta >= 0 ? "▲" : "▼"} {Math.abs(wkDelta).toFixed(2)} vs previous week
          </div>
        )}
      </Card>
      <Card testId="kpi-category-split" icon={UtensilsCrossed} label="Restaurant vs Room" className="d3">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <div className="flex items-center gap-1 text-xs text-slate-500"><UtensilsCrossed className="h-3 w-3" /> Restaurant</div>
            <div data-testid="kpi-restaurant-avg" className="font-display text-2xl font-extrabold text-emerald-950">{fmt(k.restaurant_avg)}</div>
          </div>
          <div>
            <div className="flex items-center gap-1 text-xs text-slate-500"><BedDouble className="h-3 w-3" /> Room Stay</div>
            <div data-testid="kpi-room-avg" className="font-display text-2xl font-extrabold text-emerald-950">{fmt(k.room_avg)}</div>
          </div>
        </div>
      </Card>
      <Card testId="kpi-sentiment" icon={Smile} label="Sentiment split" className="d4">
        <div className="flex h-3 overflow-hidden rounded-full bg-slate-100">
          <div className="bg-emerald-500" style={{ width: `${k.sentiment_pct.Positive}%` }} />
          <div className="bg-amber-400" style={{ width: `${k.sentiment_pct.Neutral}%` }} />
          <div className="bg-red-500" style={{ width: `${k.sentiment_pct.Negative}%` }} />
        </div>
        <div className="mt-3 grid grid-cols-3 text-center text-xs">
          <div><div data-testid="kpi-positive-pct" className="font-bold text-emerald-700 text-base">{k.sentiment_pct.Positive}%</div>Positive</div>
          <div><div data-testid="kpi-neutral-pct" className="font-bold text-amber-700 text-base">{k.sentiment_pct.Neutral}%</div>Neutral</div>
          <div><div data-testid="kpi-negative-pct" className="font-bold text-red-600 text-base">{k.sentiment_pct.Negative}%</div>Negative</div>
        </div>
      </Card>
      <Card testId="kpi-critical" icon={AlertTriangle} label="Critical alerts (1–2★)" tone="red" className={`d5 ${k.critical_open ? "ring-2 ring-red-300" : ""}`}>
        <Big testId="kpi-critical-value">{k.critical_count}</Big>
        <div className="mt-1 text-xs font-semibold text-red-600">{k.critical_open} need urgent attention</div>
      </Card>
    </div>
  );
};
